import { Component, computed, inject, model, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    Button,
    ModalAdapter,
    ModalContainer,
    ModalHeader,
    ToastService,
} from "@malirang/front-share";
import {
    DocumentTemplateCategoryService,
    ProductCategoryService,
} from "@malirang/api-client";
import { rxResource } from "@angular/core/rxjs-interop";
import {
    CdkDragDrop,
    CdkDropList,
    moveItemInArray,
} from "@angular/cdk/drag-drop";
import { ProductCategoryItemComponent } from "./product-category-item/product-category-item.component";
import { ProductCategoryFormComponent } from "./product-category-form/product-category-form.component";
import { ProductType } from "@malirang/common";

export type ProductCategoryModalProps = {
    type: keyof typeof ProductType;
};

@Component({
    selector: "app-product-category",
    templateUrl: "./product-category.modal.html",
    styleUrls: ["./product-category.modal.css"],
    imports: [
        CommonModule,
        Button,
        ModalContainer,
        ModalHeader,
        ProductCategoryItemComponent,
        ProductCategoryFormComponent,
        CdkDropList,
    ],
})
export class ProductCategoryModal extends ModalAdapter<ProductCategoryModalProps> {
    readonly service = inject(ProductCategoryService);

    type = computed(() => this.props()?.type);

    $categories = rxResource({
        stream: ({ params }) =>
            this.service.productCategoryControllerFindByType({
                type: params.type,
            }),
        params: () => ({
            type: this.type()!,
        }),
    });
    categories = this.$categories.value;

    isCreate = signal(false);
    category = model<string>("");

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(
            this.categories() || [],
            event.previousIndex,
            event.currentIndex,
        );

        this.confirmOrder();
    }

    confirmOrder() {
        const body = this.categories()?.map((item, index) => ({
            id: item.id,
            order: index,
        }));

        this.service
            .productCategoryControllerUpdateOrder({
                body: body || [],
            })
            .subscribe({
                next: () => {
                    this.toastService.success("적용되었습니다.");
                },
                error: (err) => {
                    this.toastService.error(err.message);
                },
            });
    }

    submit() {
        if (!this.category()) {
            this.toastService.error("카테고리 이름을 입력해주세요.");
            return;
        }

        this.service
            .productCategoryControllerCreate({
                body: {
                    name: this.category(),
                    type: this.type()!,
                },
            })
            .subscribe({
                next: () => {
                    this.$categories.reload();
                    this.isCreate.set(false);
                    this.category.set("");
                    this.toastService.success("카테고리가 생성되었습니다.");
                },
            });
    }
}
